/**
 * Цвета по-умолчанию
 * (сейчас используются для моб. приложения)
 */
export default {
  accent: "#4A90E2",
  error: "#FF5252",
  info: "#2196F3",
  primary: "#5181B8",
  secondary: "#424242",
  success: "#4CAF50",
  warning: "#FF9800",
}
